import { Resources } from 'constants/resources';

import { useQuery } from '@tanstack/react-query';
import { getOrderMethods, GetOrderMethodsResponse } from 'config/requests/orderMethods';
import { OrderMethodsListFilter } from 'pages/OrderMethods/OrderMethodsList';

interface IUseOrderMethodsListReturn {
  orderMethods?: GetOrderMethodsResponse;
  refetch: () => Promise<any>;
}

export function useOrderMethodsList(filters: OrderMethodsListFilter): IUseOrderMethodsListReturn {
  const { data: orderMethods, refetch } = useQuery({
    queryKey: [Resources.OrderMethods],
    queryFn: () => getOrderMethods(filters),
    enabled: false,
  });

  return { orderMethods, refetch };
}
